export default (that) => [
  {
    title: that.$l('table_label_month') || '月份',
    field: 'month',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    formatter: ({ cellValue }) => cellValue + '月',
  },
  {
    title: that.$l('table_label_plannedSales') || '预计销量',
    field: 'plannedSales',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_unitPrice') || '客单价',
    field: 'unitPrice',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_salesAmount') || '销售额',
    field: 'salesAmount',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_profitRate') || '利润率',
    field: 'profitRate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => cellValue + '%',
  },
  {
    title: that.$l('table_label_profitAmount') || '当月利润额',
    field: 'profitAmount',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalProfitAmount') || '累计利润额',
    field: 'totalProfitAmount',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
]
